import React from "react";
import Card from "react-bootstrap/Card";
import { GiGalaxy } from "react-icons/gi";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">

          <p style={{ textAlign: "justify" }}>
            Hi, I’m <span className="purple">Diksha Jha</span> — a Computer Science student at{" "}
            <span className="purple">KIET Group of Institutions</span>, based in{" "}
            <span className="purple">Delhi-NCR, India</span>.
          </p>

          <ul>
            <li className="about-activity">
              <GiGalaxy /> Building <span className="purple">scalable</span> and{" "}
              <span className="purple">user-focused</span> web applications
            </li>

            <li className="about-activity">
              <GiGalaxy /> Exploring <span className="purple">Generative AI</span> to develop{" "}
              <span className="purple">real-world solutions</span>
            </li>

            <li className="about-activity">
              <GiGalaxy /> Strong foundation in <span className="purple">full-stack development</span>{" "}
              (React, Node.js, MongoDB)
            </li>

            <li className="about-activity">
              <GiGalaxy /> Writing <span className="purple">clean</span>,{" "}
              <span className="purple">efficient</span>, and{" "}
              <span className="purple">maintainable code</span>
            </li>

            <li className="about-activity">
              <GiGalaxy /> Focused on <span className="purple">continuous learning</span> through{" "}
              <span className="purple">building and experimentation</span>
            </li>

            <li className="about-activity">
              <GiGalaxy /> A <span className="purple">creative thinker</span> shaped by writing, reading, and new experiences
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Code with intent. Build with impact."
          </p>

          <footer className="blockquote-footer">Diksha</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;